<div class="flex flex-col h-full">
  <div class="flex py-2 justify-between">
    <div class="flex w-1/5">
      <elcia-search [control]="filterForm.controls.searchTerm"/>
    </div>
    <div class="flex gap-2">
      <elcia-button (onClick)="toggleFilterDisplayed()" [icon]="'filter'"
                    [severity]="isFilterDisplayed() ? 'primary' : 'secondary'"/>
      <elcia-button (onClick)="showForm()" [icon]="'plus'"/>
    </div>
  </div>

  @if (isFilterDisplayed()) {
    <elcia-filter-container>
      <elcia-account-type-dropdown [control]="filterForm.controls.accountTypes" [isMulti]="true"/>
    </elcia-filter-container>
  }

  <div class="flex-1 overflow-hidden">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-accounting-account-grid
        (accountingAccountSelected)="onAccountingCodeSelect($event)"
        (onDelete)="onAccountingCodeDelete($event)"
        [accountingAccounts]="accountingAccounts()"/>
    }
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    (onDelete)="deleteAccountingCode()"
    [isActionLoading]="isFormSaving()"
    [mustDisplayDeleteButton]="isEditMode()"
    [size]="'medium'"
    [title]="'entity.accounting-account' | translate">

    @if (isLoadingSelectedAccountingAccount()) {
      <elcia-loader/>
    } @else {
      <elcia-accounting-account-form
        (onSubmit)="submit($event)"
        [initialValue]="store.selectedAccountingAccount() ?? undefined"
      />
    }
  </elcia-dialog>
}
